export const MOCK_STOCK_JOURNAL = [
  {
    id: 1,
    date: "2026-07-26T10:30:00Z",
    movementType: "Receipt",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: 500,
    runningBalance: 500,
    reference: "PO-10024",
    recordedBy: "Ramesh Kumar",
  },
  {
    id: 2,
    date: "2026-07-26T11:15:00Z",
    movementType: "Reservation",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: -240,
    runningBalance: 260,
    reference: "ALC-0027",
    recordedBy: "Ramesh Kumar",
  },
  {
    id: 3,
    date: "2026-07-26T14:00:00Z",
    movementType: "Transfer Out",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: -100,
    runningBalance: 160,
    reference: "TRF-9001",
    recordedBy: "Arul Selvan",
  },
  {
    id: 4,
    date: "2026-07-26T16:30:00Z",
    movementType: "Transfer In",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Peelamedu Depot",
    batchNumber: "BCH-MCB-01",
    quantity: 100,
    runningBalance: 100,
    reference: "TRF-9001",
    recordedBy: "Arul Selvan",
  },
  {
    id: 5,
    date: "2026-07-27T09:10:00Z",
    movementType: "Outward",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: -50,
    runningBalance: 110,
    reference: "INV-4567",
    recordedBy: "Ramesh Kumar",
  },
  {
    id: 6,
    date: "2026-07-27T11:45:00Z",
    movementType: "Return",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: 10,
    runningBalance: 120,
    reference: "RET-081",
    recordedBy: "Ramesh Kumar",
  },
  {
    id: 7,
    date: "2026-07-27T15:20:00Z",
    movementType: "Revocation",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: 60,
    runningBalance: 180,
    reference: "ALC-0027",
    recordedBy: "Ramesh Kumar",
  },
  {
    id: 8,
    date: "2026-07-28T10:05:00Z",
    movementType: "Defect Adjustment",
    productId: "prod-101",
    productName: "MCB 32A C-Curve 3-Pole",
    partNumber: "LS-MCB-32C3",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-MCB-01",
    quantity: -15,
    runningBalance: 165,
    reference: "ADJ-221",
    recordedBy: "Arul Selvan",
  },
  {
    id: 9,
    date: "2026-07-28T13:45:00Z",
    movementType: "Receipt",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: 80,
    runningBalance: 80,
    reference: "PO-10025",
    recordedBy: "Srinivasan M",
  },
  {
    id: 10,
    date: "2026-07-28T15:30:00Z",
    movementType: "Reservation",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: -30,
    runningBalance: 50,
    reference: "ALC-0028",
    recordedBy: "Srinivasan M",
  },
  {
    id: 11,
    date: "2026-07-29T10:15:00Z",
    movementType: "Transfer Out",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: -20,
    runningBalance: 30,
    reference: "TRF-9002",
    recordedBy: "Karthik R",
  },
  {
    id: 12,
    date: "2026-07-29T14:20:00Z",
    movementType: "Transfer In",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Mysore",
    batchNumber: "BCH-PUMP-05",
    quantity: 20,
    runningBalance: 20,
    reference: "TRF-9002",
    recordedBy: "Karthik R",
  },
  {
    id: 13,
    date: "2026-07-30T09:00:00Z",
    movementType: "Outward",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: -10,
    runningBalance: 20,
    reference: "INV-4568",
    recordedBy: "Srinivasan M",
  },
  {
    id: 14,
    date: "2026-07-30T11:30:00Z",
    movementType: "Return",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: 2,
    runningBalance: 22,
    reference: "RET-082",
    recordedBy: "Srinivasan M",
  },
  {
    id: 15,
    date: "2026-07-30T15:00:00Z",
    movementType: "Revocation",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: 10,
    runningBalance: 32,
    reference: "ALC-0028",
    recordedBy: "Srinivasan M",
  },
  {
    id: 16,
    date: "2026-07-31T10:10:00Z",
    movementType: "Defect Adjustment",
    productId: "prod-102",
    productName: "Submersible Pump Type A",
    partNumber: "WP-SUB-A01",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PUMP-05",
    quantity: -4,
    runningBalance: 28,
    reference: "ADJ-222",
    recordedBy: "Karthik R",
  },
  {
    id: 17,
    date: "2026-07-31T13:30:00Z",
    movementType: "Receipt",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: 400,
    runningBalance: 400,
    reference: "PO-10026",
    recordedBy: "Vijay Sundar",
  },
  {
    id: 18,
    date: "2026-07-31T16:00:00Z",
    movementType: "Reservation",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: -150,
    runningBalance: 250,
    reference: "ALC-0029",
    recordedBy: "Vijay Sundar",
  },
  {
    id: 19,
    date: "2026-08-01T10:00:00Z",
    movementType: "Transfer Out",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: -50,
    runningBalance: 200,
    reference: "TRF-9003",
    recordedBy: "Karthik R",
  },
  {
    id: 20,
    date: "2026-08-01T14:15:00Z",
    movementType: "Transfer In",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-VALVE-12",
    quantity: 50,
    runningBalance: 50,
    reference: "TRF-9003",
    recordedBy: "Karthik R",
  },
  {
    id: 21,
    date: "2026-08-02T09:30:00Z",
    movementType: "Outward",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: -60,
    runningBalance: 140,
    reference: "INV-4569",
    recordedBy: "Vijay Sundar",
  },
  {
    id: 22,
    date: "2026-08-02T11:20:00Z",
    movementType: "Return",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: 5,
    runningBalance: 145,
    reference: "RET-083",
    recordedBy: "Vijay Sundar",
  },
  {
    id: 23,
    date: "2026-08-02T15:40:00Z",
    movementType: "Revocation",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: 30,
    runningBalance: 175,
    reference: "ALC-0029",
    recordedBy: "Vijay Sundar",
  },
  {
    id: 24,
    date: "2026-08-03T10:15:00Z",
    movementType: "Defect Adjustment",
    productId: "prod-103",
    productName: "Gate Valve DN100 PN16",
    partNumber: "FL-GVAL-100",
    warehouse: "Warehouse Chennai",
    batchNumber: "BCH-VALVE-12",
    quantity: -8,
    runningBalance: 167,
    reference: "ADJ-223",
    recordedBy: "Karthik R",
  },
  {
    id: 25,
    date: "2026-08-03T11:30:00Z",
    movementType: "Receipt",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: 1000,
    runningBalance: 1000,
    reference: "PO-10027",
    recordedBy: "Srinivasan M",
  },
  {
    id: 26,
    date: "2026-08-03T14:45:00Z",
    movementType: "Reservation",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: -500,
    runningBalance: 500,
    reference: "ALC-0030",
    recordedBy: "Srinivasan M",
  },
  {
    id: 27,
    date: "2026-08-03T16:15:00Z",
    movementType: "Transfer Out",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: -120,
    runningBalance: 380,
    reference: "TRF-9004",
    recordedBy: "Karthik R",
  },
  {
    id: 28,
    date: "2026-08-03T17:00:00Z",
    movementType: "Transfer In",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Mysore",
    batchNumber: "BCH-LED-09",
    quantity: 120,
    runningBalance: 120,
    reference: "TRF-9004",
    recordedBy: "Karthik R",
  },
  {
    id: 29,
    date: "2026-08-04T09:15:00Z",
    movementType: "Outward",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: -200,
    runningBalance: 180,
    reference: "INV-4570",
    recordedBy: "Srinivasan M",
  },
  {
    id: 30,
    date: "2026-08-04T10:30:00Z",
    movementType: "Return",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: 15,
    runningBalance: 195,
    reference: "RET-084",
    recordedBy: "Srinivasan M",
  },
  {
    id: 31,
    date: "2026-08-04T11:45:00Z",
    movementType: "Revocation",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: 80,
    runningBalance: 275,
    reference: "ALC-0030",
    recordedBy: "Srinivasan M",
  },
  {
    id: 32,
    date: "2026-08-04T13:00:00Z",
    movementType: "Defect Adjustment",
    productId: "prod-104",
    productName: "LED Panel Light 15W 6500K",
    partNumber: "LT-PAN-15W",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-LED-09",
    quantity: -25,
    runningBalance: 250,
    reference: "ADJ-224",
    recordedBy: "Karthik R",
  },
  {
    id: 33,
    date: "2026-08-04T14:15:00Z",
    movementType: "Receipt",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: 12,
    runningBalance: 12,
    reference: "PO-10028",
    recordedBy: "Arul Selvan",
  },
  {
    id: 34,
    date: "2026-08-04T14:45:00Z",
    movementType: "Reservation",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: -4,
    runningBalance: 8,
    reference: "ALC-0031",
    recordedBy: "Arul Selvan",
  },
  {
    id: 35,
    date: "2026-08-04T15:10:00Z",
    movementType: "Transfer Out",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: -2,
    runningBalance: 6,
    reference: "TRF-9005",
    recordedBy: "Arul Selvan",
  },
  {
    id: 36,
    date: "2026-08-04T15:40:00Z",
    movementType: "Transfer In",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Warehouse Bangalore",
    batchNumber: "BCH-PNEU-02",
    quantity: 2,
    runningBalance: 2,
    reference: "TRF-9005",
    recordedBy: "Srinivasan M",
  },
  {
    id: 37,
    date: "2026-08-04T16:00:00Z",
    movementType: "Outward",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: -1,
    runningBalance: 5,
    reference: "INV-4571",
    recordedBy: "Arul Selvan",
  },
  {
    id: 38,
    date: "2026-08-04T16:20:00Z",
    movementType: "Return",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: 1,
    runningBalance: 6,
    reference: "RET-085",
    recordedBy: "Arul Selvan",
  },
  {
    id: 39,
    date: "2026-08-04T16:45:00Z",
    movementType: "Revocation",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: 2,
    runningBalance: 8,
    reference: "ALC-0031",
    recordedBy: "Arul Selvan",
  },
  {
    id: 40,
    date: "2026-08-04T17:00:00Z",
    movementType: "Defect Adjustment",
    productId: "prod-105",
    productName: "Rotary Air Compressor 10HP",
    partNumber: "AC-ROT-10H",
    warehouse: "Coimbatore Central Warehouse",
    batchNumber: "BCH-PNEU-02",
    quantity: -1,
    runningBalance: 7,
    reference: "ADJ-225",
    recordedBy: "Arul Selvan",
  },
];
